export default __webpack_public_path__ + "static/The Backdrop_image 3@2x-c067a874901da78d63573bed3d0fdd27.jpg";